<template>
  <v-data-table hide-default-header hide-default-footer style="padding: 30px">
    <template v-slot:top>
      <div>
        <div>
          <v-layout>
            <v-row>
              <v-col cols="12" md="6">
                <div style="font-size: 20px; font-weight: 600" class="mb-5">
                  {{ title }}
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <!-- <div align="right">
                  <v-btn
                    depressed
                    color="primary"
                    to="/listRegister"
                    style="margin-left: 10px"
                    >Registration List</v-btn
                  >
                </div> -->
              </v-col>
            </v-row>
          </v-layout>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
              <v-row>
                <v-col cols="12" md="6">
                  <div>
                    <v-toolbar color="#06377a" dark style="box-shadow: none">
                      <v-toolbar-title> Naming Convention </v-toolbar-title>
                    </v-toolbar>
                    <div class="form-box">
                      <table width="100%" class="fltable">
                        <tr>
                          <td width="30%">
                            <b class="title-table">Material No.</b>
                          </td>
                          <td>
                            <v-template>
                              <v-row>
                                <v-text-field
                                  v-model="material_number"
                                  placeholder="SAP Generated"
                                  disabled
                                  solo
                                ></v-text-field>
                              </v-row>
                            </v-template>
                          </td>
                        </tr>
                        <tr>
                          <td width="30%">
                            <b class="title-table">Old Material No.</b>
                          </td>
                          <td>
                            <v-template>
                              <v-row>
                                <v-text-field
                                  v-model="old_material_number"
                                  disabled
                                  placeholder="SAP Old Material Number"
                                  solo
                                ></v-text-field>
                              </v-row>
                            </v-template>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b class="title-table"
                              >Item Name <span class="required">*</span></b
                            >
                          </td>
                          <td width="55%">
                            <span>
                              <v-row>
                                <v-dialog
                                  v-model="dialog"
                                  transition="fade-transition"
                                  max-width="1200px"
                                  scrollable
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-on:click="modalInc()"
                                      v-model="inc"
                                      placeholder="Enter Item Name"
                                      :disabled="disabledMaterial"
                                      readonly
                                      solo
                                      append-icon="search"
                                      @click:append="modalInc()"
                                      :rules="[
                                        (v) => !!v || '*Item Name is required',
                                      ]"
                                    ></v-text-field>
                                  </template>

                                  <v-card>
                                    <v-toolbar
                                      dark
                                      color="#06377a"
                                      style="box-shadow: none"
                                    >
                                      <v-toolbar-title>
                                        INC (Item Name Code)
                                      </v-toolbar-title>
                                      <v-spacer></v-spacer>

                                      <v-btn
                                        class="mr-1"
                                        icon
                                        dark
                                        @click="dialog = false"
                                      >
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </v-toolbar>
                                    <v-card-text>
                                      <div class="px-4">
                                        <v-layout row>
                                          <v-flex md12>
                                            <div
                                              class="sticky-form pt-4 pb-5 d-flex"
                                              style="background-color: #fff"
                                            >
                                              <v-row>
                                                <v-col col="6">
                                                  <v-text-field
                                                    v-model="searchInc"
                                                    v-on:keyup.enter="getInc()"
                                                    placeholder="Enter INC Code / INC Name / Colloquial Name"
                                                    outlined
                                                    append-icon="search"
                                                    hide-details
                                                    :disabled="disabledMaterial"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                  <v-select
                                                    label="Sort By"
                                                    item-value="sort_by_id"
                                                    item-text="sort_by_name"
                                                    v-model="sort_by_inc"
                                                    :items="list_sort_by"
                                                    v-on:change="getInc()"
                                                    hide-details
                                                    outlined
                                                  ></v-select>
                                                </v-col>

                                                <v-col cols="3">
                                                  <v-select
                                                    v-model="sort_type_inc"
                                                    :items="['ASC', 'DESC']"
                                                    label="Sort Type"
                                                    v-on:change="getInc()"
                                                    hide-details
                                                    outlined
                                                  ></v-select>
                                                </v-col>
                                              </v-row>
                                            </div>

                                            <div
                                              align="center"
                                              v-if="loading_inc"
                                              class="pt-10"
                                              style="min-height: 420px"
                                            >
                                              <v-progress-circular
                                                :size="40"
                                                color="primary"
                                                indeterminate
                                              ></v-progress-circular>
                                              <div class="mt-3">
                                                Loading Data INC
                                              </div>
                                            </div>

                                            <v-simple-table
                                              v-if="list_inc && !loading_inc"
                                            >
                                              <template v-slot:default>
                                                <thead>
                                                  <tr>
                                                    <th class="text-left">
                                                      INC Code
                                                    </th>
                                                    <th class="text-left">
                                                      INC Name
                                                    </th>
                                                    <th class="text-left">
                                                      Short Name
                                                    </th>
                                                    <th class="text-left">
                                                      Colloquial Name
                                                    </th>
                                                    <th class="text-center">
                                                      action
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody style="height: 100px">
                                                  <tr
                                                    v-for="item in list_inc"
                                                    v-bind:key="item.INC_CODE"
                                                  >
                                                    <td width="150">
                                                      {{ item.INC_CODE }}
                                                    </td>
                                                    <td width="350">
                                                      {{ item.INC_NAME }}
                                                    </td>
                                                    <td width="350">
                                                      {{ item.SHORT_NAME }}
                                                    </td>
                                                    <td width="150">
                                                      {{ item.COLLOQUIAL_NAME }}
                                                    </td>
                                                    <td align="center">
                                                      <v-btn
                                                        small
                                                        color="default"
                                                        depressed
                                                        v-on:click="
                                                          selectInc(
                                                            $event,
                                                            item.INC_CODE,
                                                            item.SHORT_NAME,
                                                            item.COLLOQUIAL_NAME
                                                          )
                                                        "
                                                        >Pilih</v-btn
                                                      >
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </template>
                                            </v-simple-table>
                                          </v-flex>
                                        </v-layout>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-dialog>
                              </v-row>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b class="title-table"
                              >INC Code <span class="required">*</span></b
                            >
                          </td>
                          <td class="pb-3" style="font-size: 16px">
                            <template>
                              <v-row>
                                <v-text-field
                                  v-model="inc_code"
                                  placeholder="Enter INC Code"
                                  solo
                                  disabled
                                  :rules="[
                                    (v) => !!v || '*INC Code is required',
                                  ]"
                                ></v-text-field>
                              </v-row>
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Attribute <span class="required">*</span></b>
                          </td>
                          <td class="pb-8">
                            <template>
                              <v-row>
                                <v-dialog
                                  v-model="dialog2"
                                  max-width="900px"
                                  scrollable
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      depressed
                                      color="success"
                                      class="no-uppercase"
                                      :disabled="!inc_code || disabledMaterial"
                                      style="margin-top: 5px; margin-bottom: 20px"
                                      v-on:click="modalAttribute()"
                                    >
                                      <v-icon class="mr-1"
                                        >mdi-view-list</v-icon
                                      >
                                      Fill Attribute
                                    </v-btn>
                                  </template>
                                  <v-card tile>
                                    <v-toolbar flat dark color="#06377a">
                                      <v-toolbar-title>
                                        Fill Attribute Value
                                      </v-toolbar-title>
                                      <v-spacer></v-spacer>

                                      <v-btn
                                        class="mr-1"
                                        icon
                                        dark
                                        @click="dialog2 = false"
                                      >
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </v-toolbar>
                                    <v-card-text>
                                      <v-container>
                                        <v-layout>
                                          <v-flex
                                            md7
                                            style="padding-right: 30px"
                                          >
                                            <div
                                              style="
                                                height: 450px;
                                                overflow-y: scroll;
                                                padding-right: 20px;
                                              "
                                            >
                                              <table
                                                width="100%"
                                                class="general-table"
                                              >
                                                <tr
                                                  v-for="(item,
                                                  index) in list_inc_attribute"
                                                  v-bind:key="item.ATTRIBUTE_ID"
                                                >
                                                  <td>
                                                    {{ item.ATTRIBUTE_DESC }}
                                                    <v-text-field
                                                      v-model="attr[index]"
                                                      :maxlength="40"
                                                      :placeholder="
                                                        'ENTER ' +
                                                          item.ATTRIBUTE_DESC
                                                      "
                                                      v-on:keyup="setItemDesc()"
                                                      solo
                                                      :disabled="
                                                        disabledAttr[index]
                                                      "
                                                    ></v-text-field>
                                                  </td>

                                                  <td
                                                    style="padding: 30px 0px 0px 5px"
                                                  >
                                                    <v-tooltip bottom>
                                                      <template
                                                        v-slot:activator="{
                                                          on,
                                                        }"
                                                      >
                                                        <span v-on="on">
                                                          <v-icon
                                                            medium
                                                            color="orange"
                                                            class="mr-2"
                                                          >
                                                            mdi-help-circle
                                                          </v-icon>
                                                        </span>
                                                      </template>

                                                      <div
                                                        style="max-width: 280px"
                                                        v-if="item.EXPLANATION"
                                                      >
                                                        {{ item.EXPLANATION }}
                                                      </div>
                                                      <div
                                                        style="max-width: 280px"
                                                        v-if="!item.EXPLANATION"
                                                      >
                                                        This attribute has no
                                                        explanation
                                                      </div>
                                                    </v-tooltip>
                                                  </td>
                                                </tr>

                                                <tr>
                                                  <td>
                                                    ADDITIONAL INFO
                                                    <v-text-field
                                                      v-on:keyup="setItemDesc()"
                                                      v-model="
                                                        AttrAdditionalInfo
                                                      "
                                                      placeholder="ENTER ADDITIONAL INFO"
                                                      :disabled="
                                                        disabledMaterial
                                                      "
                                                      solo
                                                    ></v-text-field>
                                                  </td>
                                                  <td
                                                    style="padding: 30px 0px 0px 5px"
                                                  >
                                                    <v-tooltip bottom>
                                                      <template
                                                        v-slot:activator="{
                                                          on,
                                                        }"
                                                      >
                                                        <span v-on="on">
                                                          <v-icon
                                                            medium
                                                            color="orange"
                                                            class="mr-2"
                                                          >
                                                            mdi-help-circle
                                                          </v-icon>
                                                        </span>
                                                      </template>

                                                      <div
                                                        style="max-width: 250px"
                                                      >
                                                        Additional text for item
                                                        description
                                                      </div>
                                                    </v-tooltip>
                                                  </td>
                                                </tr>

                                                <tr>
                                                  <td>
                                                    Part Number
                                                    <v-text-field
                                                      v-model="part_no_modal"
                                                      placeholder="Enter Part Number"
                                                      :disabled="
                                                        disabledMaterial
                                                      "
                                                      solo
                                                      @keyup="setItemDesc"
                                                    ></v-text-field>
                                                  </td>
                                                </tr>

                                                <tr>
                                                  <td>
                                                    Manufacturer
                                                    <v-autocomplete
                                                      item-text="description"
                                                      item-value="manufacturer_code"
                                                      clearable
                                                      v-model="
                                                        manufacturer_modal
                                                      "
                                                      :items="list_manufacturer"
                                                      :disabled="
                                                        disabledMaterial
                                                      "
                                                      label="Choose Manufacturer"
                                                      @change="setItemDesc"
                                                      solo
                                                    ></v-autocomplete>
                                                  </td>
                                                </tr>
                                              </table>
                                            </div>
                                          </v-flex>

                                          <v-flex md8>
                                            <table width="100%" class="fltable">
                                              <tr>
                                                <td>
                                                  Short Description
                                                  <br /><b
                                                    >{{ countString }} / 40</b
                                                  >

                                                  <v-textarea
                                                    :maxlength="40"
                                                    :value="modalItemDesc"
                                                    readonly
                                                    :disabled="disabledMaterial"
                                                    solo
                                                  ></v-textarea>
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>
                                                  Basic Data Text
                                                  <v-textarea
                                                    :value="modalAdditionalInfo"
                                                    readonly
                                                    solo
                                                  ></v-textarea>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <v-expansion-panels
                                                    :flat="true"
                                                  >
                                                    <v-expansion-panel>
                                                      <v-expansion-panel-header
                                                        ><span
                                                          style="
                                                            font-size: 12px;
                                                            text-decoration: underline;
                                                            color: blue;
                                                          "
                                                          >Previous
                                                          Information</span
                                                        ></v-expansion-panel-header
                                                      >
                                                      <v-expansion-panel-content>
                                                        <table
                                                          width="100%"
                                                          style="font-size: 11px"
                                                          cellspacing="0"
                                                        >
                                                          <tr>
                                                            <td colspan="2">
                                                              <b
                                                                >Requester
                                                                Attributes
                                                                Value</b
                                                              >
                                                              <hr />
                                                            </td>
                                                          </tr>

                                                          <tr
                                                            v-for="inc in list_inc_parse"
                                                            v-bind:key="
                                                              inc.ATTRIBUTE_ID
                                                            "
                                                          >
                                                            <td>
                                                              {{ inc.desc }}
                                                            </td>
                                                            <td width="50%">
                                                              <b
                                                                class="title-table"
                                                                >{{
                                                                  inc.val
                                                                }}</b
                                                              >
                                                            </td>
                                                          </tr>

                                                          <tr>
                                                            <td colspan="2">
                                                              <br />
                                                              <b
                                                                >Requester Item
                                                                Description</b
                                                              >
                                                              <hr />
                                                            </td>
                                                          </tr>
                                                          <tr>
                                                            <td colspan="2">
                                                              {{
                                                                requester_description
                                                              }}
                                                            </td>
                                                          </tr>

                                                          <tr>
                                                            <td colspan="2">
                                                              <br />
                                                              <b
                                                                >Requester Item
                                                                Information</b
                                                              >
                                                              <hr />
                                                            </td>
                                                          </tr>
                                                          <tr>
                                                            <td colspan="2">
                                                              {{
                                                                requester_additional_info
                                                              }}
                                                            </td>
                                                          </tr>
                                                        </table>
                                                      </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                  </v-expansion-panels>
                                                </td>
                                              </tr>
                                            </table>
                                          </v-flex>
                                        </v-layout>
                                      </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                      <small>
                                        *All informations will be combined in to
                                        Item Description
                                      </small>
                                      <v-spacer />
                                      <v-btn
                                        color="error"
                                        dark
                                        depressed
                                        @click="dialog2 = false"
                                        >Close</v-btn
                                      >
                                      &nbsp;
                                      <v-btn
                                        color="primary"
                                        depressed
                                        :disabled="disabledAdd"
                                        @click="addDescription()"
                                      >
                                        Add
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-row>
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b class="title-table">
                              Short Description
                              <span class="required">*</span></b
                            >
                          </td>
                          <td>
                            <template>
                              <v-row>
                                <v-textarea
                                  :maxlength="40"
                                  disabled
                                  v-model="description"
                                  placeholder="Enter Description"
                                  solo
                                  :rules="[
                                    (v) => !!v || '*Description is required',
                                  ]"
                                ></v-textarea>
                              </v-row>
                            </template>
                          </td>
                        </tr>

                        <tr>
                          <td><b class="title-table">Basic Data Text</b></td>
                          <td>
                            <template>
                              <v-row>
                                <v-textarea
                                  v-model="additional_information"
                                  disabled
                                  placeholder="Enter Basic Data Text"
                                  solo
                                  class="mb-5"
                                  style="min-height: 120px"
                                ></v-textarea>
                              </v-row>
                            </template>
                          </td>
                        </tr>

                        <tr>
                          <td><b class="title-table">Colloquial Name</b></td>
                          <td>
                            <template>
                              <div
                                style="color: grey; font-size: 10px; margin-bottom: 10px"
                                v-if="colloquial_name_info"
                              >
                                Existing Colloquial Name :
                                {{ colloquial_name_info }}
                              </div>
                              <v-row>
                                <v-text-field
                                  v-model="colloquial_name"
                                  placeholder="Enter Colloquial Name"
                                  solo
                                  :disabled="disabledMaterial"
                                ></v-text-field>
                              </v-row>
                            </template>
                          </td>
                        </tr>

                        <tr>
                          <td><b class="title-table">Manufacturer</b></td>
                          <td>
                            <template>
                              <v-row>
                                <v-autocomplete
                                  item-text="description"
                                  item-value="manufacturer_code"
                                  v-model="manufacturer"
                                  :items="list_manufacturer"
                                  label="Choose Manufacture"
                                  disabled="disabledMaterial"
                                  readonly
                                  @change="changeDescription()"
                                  solo
                                ></v-autocomplete>
                              </v-row>
                            </template>
                          </td>
                        </tr>

                        <tr>
                          <td width="30%">
                            <b class="title-table">Part Number</b>
                          </td>
                          <td>
                            <v-template>
                              <v-row>
                                <v-text-field
                                  v-model="part_no"
                                  placeholder="Enter Part Number"
                                  disabled="disabledMaterial"
                                  readonly
                                  @keyup="changeDescription()"
                                  solo
                                ></v-text-field>
                              </v-row>
                            </v-template>
                          </td>
                        </tr>
                        <tr>
                          <td width="30%">
                            <b class="title-table">Remarks</b>
                          </td>
                          <td>
                            <v-template>
                              <v-row>
                                <v-text-field
                                  v-model="remarks"
                                  placeholder="Enter Remarks"
                                  solo
                                ></v-text-field>
                              </v-row>
                            </v-template>
                          </td>
                        </tr>
                        <tr style="display: none">
                          <td><b class="title-table">Notes</b></td>
                          <td>
                            <template>
                              <v-row>
                                <v-textarea
                                  v-model="message"
                                  :disabled="isDisabled"
                                  placeholder="Enter Notes"
                                  solo
                                ></v-textarea>
                              </v-row>
                            </template>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-toolbar color="#06377a" dark style="box-shadow: none">
                    <v-toolbar-title> General Information </v-toolbar-title>
                  </v-toolbar>
                  <div class="form-box">
                    <table width="100%" class="fltable">
                      <tr>
                        <td><b>Attachment</b></td>
                        <td>
                          <v-row>
                            <v-file-input
                              v-model="attachment"
                              ref="attachment"
                              chips
                              show-size
                              multiple
                              prepend-icon="mdi-file-upload"
                              label="Choose File Upload"
                              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx, .xls, .pdf, .jpg, .png, .jpeg, .doc, .docx"
                            ></v-file-input>
                          </v-row>

                          <div>
                            <MaterialFile
                              v-if="request_no"
                              :request_no="request_no"
                            ></MaterialFile>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td width="35%">
                          <b class="title-table"
                            >Company <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="company_name"
                              item-value="company_code"
                              v-model="company"
                              :items="list_company"
                              label="Choose Company"
                              solo
                              :rules="[(v) => !!v || '*Company is required']"
                              @change="getPlant()"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td width="35%">
                          <b class="title-table"
                            >Plant <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="plant_code"
                              v-model="plant"
                              :items="list_plant"
                              label="Choose Plant"
                              solo
                              :rules="[(v) => !!v || '*Plant is required']"
                              @change="getStorageLocation()"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b class="title-table"
                            >Industry Sector <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="industry_sector_code"
                              v-model="industry_sector"
                              :items="list_industry_sector"
                              label="Choose Industry Sector"
                              solo
                              :rules="[
                                (v) => !!v || '*Industry Sector is required',
                              ]"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b class="title-table"
                            >Material Type <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="material_type_code"
                              v-model="material_type"
                              :items="list_material_type"
                              label="Choose Material Type"
                              solo
                              :rules="[
                                (v) => !!v || '*Material Type is required',
                              ]"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b class="title-table"
                            >Base Unit <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="base_unit_code"
                              v-model="base_unit"
                              :items="list_base_unit"
                              label="Choose Base unit"
                              solo
                              :rules="[(v) => !!v || '*Base Unit is required']"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td><b class="title-table">Order Unit</b></td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="order_unit_code"
                              v-model="order_unit"
                              :items="list_order_unit"
                              label="Choose Order unit"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b class="title-table"
                            >Division <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="divisi_code"
                              v-model="divisi"
                              :items="list_divisi"
                              label="Choose Division"
                              solo
                              :rules="[(v) => !!v || '*Division is required']"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b class="title-table"
                            >Material Group <span class="required">*</span></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="material_group_code"
                              v-model="material_group"
                              :items="list_material_group"
                              label="Choose Material Group"
                              solo
                              :rules="[
                                (v) => !!v || '*Material Group is required',
                              ]"
                              @change="getExternalGroup()"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td><b class="title-table">External Group</b></td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="external_group_code"
                              v-model="external_group"
                              :items="list_external_group"
                              label="Choose External Group"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td><b class="title-table">Lab/Office</b></td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="lab_office_code"
                              v-model="lab_office"
                              :items="list_lab_office"
                              label="Choose Lab Office"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td><b class="title-table">Basic Material</b></td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="basic_material_code"
                              v-model="basic_material"
                              :items="list_basic_material"
                              label="Choose Basic Material"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Purchasing Group <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="purchasing_group_code"
                              v-model="purchasing_group"
                              :items="list_purchasing_group"
                              label="Choose Purchasing Group"
                              solo
                              :rules="[
                                (v) => !!v || '*Purchasing Group is required',
                              ]"
                              @change="getDataMrp()"
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Purchasing Value Key
                            <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="purchasing_value_name"
                              item-value="purchasing_value_code"
                              v-model="purchasing_value_key"
                              :items="list_purchasing_value"
                              label="Choose Purchasing Value Key"
                              :rules="[
                                (v) =>
                                  !!v || '*Purchasing Value Key is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td><b class="title-table">Automatic PO</b></td>
                        <td>
                          <v-row>
                            <v-checkbox
                              v-model="automatic_po"
                              style="margin-top: 5px"
                              disabled
                            ></v-checkbox>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td><b class="title-table">Source List</b></td>
                        <td>
                          <v-row>
                            <v-checkbox
                              v-model="source_list"
                              style="margin-top: 5px"
                            ></v-checkbox>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table"
                            >MRP Group
                            <span v-if="is_required" class="required"
                              >*</span
                            ></b
                          >
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="mrp_group_code"
                              v-model="mrp_group"
                              :items="list_mrp_group"
                              label="Choose MRP Group"
                              :rules="
                                is_required
                                  ? [(v) => !!v || '*MRP Group is required']
                                  : []
                              "
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            MRP Type
                            <span v-if="is_required" class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="mrp_type_code"
                              v-model="mrp_type"
                              :items="list_mrp_type"
                              label="Choose MRP Type"
                              :rules="
                                is_required
                                  ? [(v) => !!v || '*MRP Type is required']
                                  : []
                              "
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            MRP Control
                            <span v-if="is_required" class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="mrp_control_code"
                              v-model="mrp_control"
                              :items="list_mrp_control"
                              label="Choose MRP Control"
                              :rules="
                                is_required
                                  ? [(v) => !!v || '*MRP Control is required']
                                  : []
                              "
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            MRP Profile
                            <span v-if="is_required" class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="mrp_profile_code"
                              v-model="mrp_profile"
                              :items="list_mrp_profile"
                              label="Choose MRP Profile"
                              :rules="
                                is_required
                                  ? [(v) => !!v || '*MRP Profile is required']
                                  : []
                              "
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Lot Size Procedure
                            <span v-if="is_required" class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="lot_size_procedure_code"
                              v-model="lot_size_procedure"
                              :items="list_lot_size_procedure"
                              label="Choose Lot Size Procedure"
                              :rules="
                                is_required
                                  ? [
                                      (v) =>
                                        !!v ||
                                        '*Lot Size Procedure is required',
                                    ]
                                  : []
                              "
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Procurement Type <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="proc_type_code"
                              v-model="proc_type"
                              :items="list_proc_type"
                              label="Choose Procurement Type"
                              :rules="[
                                (v) => !!v || '*Procurement Type is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Special Proc. <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="special_proc_code"
                              v-model="special_proc"
                              :items="list_special_proc"
                              label="Choose Special Proc."
                              :rules="[
                                (v) => !!v || '*Special Proc. is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Planned Delivery
                            <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="planned_delivery_name"
                              item-value="planned_delivery_code"
                              v-model="planned_delivery_time"
                              :items="list_planned_delivery"
                              label="Choose Planned Delivery Time"
                              :rules="[
                                (v) =>
                                  !!v || '*Planned Delivery Time is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Availibility Check <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="availibility_check_code"
                              v-model="availibility_check"
                              :items="list_availibility_check"
                              label="Choose Availibility Check"
                              :rules="[
                                (v) => !!v || '*Availibility Check is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Valuation Category <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="valuation_category_code"
                              v-model="valuation_category"
                              :items="list_valuation_category"
                              label="Choose Valuation Category Key"
                              @change="getValuationType()"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Valuation Type
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="valuation_type_name"
                              item-value="valuation_type_code"
                              v-model="valuation_type"
                              :items="list_valuation_type"
                              :disabled="valuation_category !== 'S'"
                              label="Choose Valuation Type"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Valuation Class <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="valuation_class_code"
                              v-model="valuation_class"
                              :items="list_valuation_class"
                              label="Choose Valuation Class"
                              :rules="[
                                (v) => !!v || '*Valuation Class is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Price Control <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="price_control_code"
                              v-model="price_control"
                              :items="list_price_control"
                              label="Choose Price Control"
                              :rules="[
                                (v) => !!v || '*Price Control is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b class="title-table">
                            Storage Location <span class="required">*</span>
                          </b>
                        </td>
                        <td>
                          <v-row>
                            <v-autocomplete
                              item-text="description"
                              item-value="storage_location_code"
                              v-model="storage_location"
                              :items="list_storage_location"
                              label="Choose Storage Location"
                              :rules="[
                                (v) => !!v || '*Storage Location is required',
                              ]"
                              solo
                            ></v-autocomplete>
                          </v-row>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">
                          <template v-if="list_duplication.length">
                            <div class="mt-5">
                              The part number that is being registered has the
                              potential to duplicate with the following items.
                              Please check before proceeding
                            </div>

                            <div
                              v-for="(data, index) in list_duplication"
                              :key="index"
                              class="mb-3 mt-5"
                            >
                              <v-card
                                outlined
                                :color="
                                  data.part_number === part_no_modal &&
                                  data.manufacturer === manufacturer_modal &&
                                  manufacturer_modal !== ''
                                    ? 'red'
                                    : 'orange'
                                "
                              >
                                <v-card-text
                                  style="color: #fff; font-size: 14px;"
                                >
                                  <div>
                                    <div>{{ data.description }}</div>
                                    <div>{{ data.basic_data_text }}</div>
                                    <div v-if="data.part_number">
                                      Part Number :
                                      <b>{{ data.part_number }}</b>
                                    </div>

                                    <div v-if="data.manufacturer">
                                      Manufacturer :
                                      <b>{{ data.manufacturer }}</b>
                                    </div>

                                    <div v-if="data.material_number">
                                      Material Number :
                                      <b>{{ data.material_number }}</b>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div align="right">
                            <v-btn
                              depressed
                              large
                              color="primary"
                              @click="submitMaterial('draft')"
                              :disabled="loading"
                              :loading="loading"
                              class="mr-2"
                            >
                              Save
                            </v-btn>

                            <v-btn
                              v-if="
                                (storage_role === 'CAT' &&
                                  data_material.status === 'CAT') ||
                                  storage_role === 'REQ'
                              "
                              depressed
                              large
                              color="success"
                              :disabled="loading || total_duplication > 0"
                              :loading="loading"
                              @click="submitMaterial('submit')"
                            >
                              <span v-if="storage_role === 'REQ'">Submit</span>
                              <span v-if="storage_role === 'CAT'">
                                Request Approval
                              </span>
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </v-col>
              </v-row>
            </v-layout>
          </v-form>

          <div style="padding: 20px 25px">
            <v-dialog v-model="error_dialog" max-width="500px">
              <v-card>
                <v-card-title> Warning </v-card-title>
                <v-card-text>
                  <span v-if="errors.length">
                    <b class="title-table"
                      >Please correct the following error(s) :
                    </b>
                    <ul>
                      <li v-for="error in errors" v-bind:key="error.id">
                        {{ error }}
                      </li>
                    </ul>
                  </span>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" text @click="error_dialog = false">
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="loading" persistent color="red" width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Loading..
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>

          <div style="display: none">
            <v-toolbar style="box-shadow: none !important">
              <v-toolbar-title>5 Items</v-toolbar-title>

              <v-spacer></v-spacer>
              <!-- <v-btn large icon v-on:click="deletes" style="margin-right: 10px">
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn> -->
            </v-toolbar>
          </div>
        </div>
      </div>

      <div>
        <v-snackbar
          v-model="snackbar.open"
          :timeout="snackbar.timeout ? snackbar.timeout : 6000"
          top
        >
          {{ snackbar.message_text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              :color="snackbar.button_type ? snackbar.button_type : 'primary'"
              v-bind="attrs"
              style="float: right !important"
              @click="snackbar.open = false"
            >
              {{ snackbar.button_text ? snackbar.button_text : "Close" }}
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="notification.open" max-width="350" persistent>
          <v-card>
            <v-card-title class="text-h6">
              {{ notification.title }}
            </v-card-title>

            <v-card-text>
              {{ notification.text }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed @click="routeList()">
                Oke
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <template v-slot:item.action="{ item }">
      <v-icon class="mr-2" @click="editItem(item)"> mdi-pencil-outline </v-icon>
      <!-- <v-icon @click="deletes(item)"> mdi-delete-outline </v-icon> -->
    </template>
  </v-data-table>
</template>

<script>
import MaterialFile from "../component/MaterialFile.vue"

export default {
  components: {
    MaterialFile,
  },

  data() {
    return {
      flat: true,
      shortname: "",
      design: "",
      typem: "",
      size: "",
      shape: "",
      color: "",
      inc_code: "",
      name: "Registration",
      title: "Registration Form",
      dialog: false,
      dialog2: false,
      modalItemDesc: "",
      modalAdditionalInfo: "",
      select: { BRAND_CODE: "1", BRAND_NAME: "Catterpilar" },
      errors: [],
      uom: [],
      type: [],
      disabledMaterial: false,
      error_dialog: false,
      date: "",
      isDisabled: false,
      attr: [],
      disabledAttr: [],
      disabledStock: true,
      AttrAdditionalInfo: "",
      loading: false,
      //Approval........................
      email_approval: "",
      user_approval: "",
      //searchparam................................
      searchInc: "",
      countString: 0,
      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
      //v-list.......................................
      data_material: {},
      list_inc: null,
      list_inc_attribute: [],
      list_server_code: ["GEMS", "BKES", "BC"],
      list_manufacturer: [],
      list_industry_sector: [],
      list_company: [],
      list_plant: [],
      list_material_type: [],
      list_base_unit: [],
      list_order_unit: [],
      list_divisi: [],
      list_material_group: [],
      list_external_group: [],
      list_lab_office: [],
      list_basic_material: [],
      list_purchasing_group: [],
      list_purchasing_value: [],
      list_mrp_group: [],
      list_mrp_type: [],
      list_mrp_control: [],
      list_mrp_profile: [],
      list_lot_size_procedure: [],
      list_proc_type: [],
      list_special_proc: [],
      list_availibility_check: [],
      list_valuation_category: [],
      list_valuation_class: [],
      list_price_control: [],
      list_valuation_type: [],
      list_storage_location: [],
      list_material_file: [],

      list_planned_delivery: [
        {
          planned_delivery_code: "7",
          planned_delivery_name: "7 Days",
        },
        {
          planned_delivery_code: "14",
          planned_delivery_name: "14 Days",
        },
        {
          planned_delivery_code: "21",
          planned_delivery_name: "21 Days",
        },
      ],
      //---------------------------------------------
      material_number: "",
      company: "",
      plant: "",
      industry_sector: "",
      material_type: "",
      description: "",
      base_unit: "",
      division: "",
      material_group: "",
      external_group: "",
      old_material_number: "",
      lab_office: "",
      basic_data_text: "",
      basic_material: "",
      purchasing_group: "",
      order_unit: "",
      automatic_po: "",
      purchasing_value_key: "",
      source_list: "",
      manufacturer: "",
      part_number: "",
      mrp_group: "",
      mrp_type: "",
      mrp_control: "",
      mrp_profile: "",
      lot_size_procedur: "",
      proc_type: "",
      special_proc: "",
      planned_delivery_time: "",
      availibility_check: "",
      valuation_category: "",
      valuation_class: "",
      price_control: "",
      remarks: "",
      valuation_type: "",
      part_no_modal: "",
      manufacturer_modal: "",
      storage_location: "",
      possibility_duplicate: "",

      //v-model.......................................
      request_no: "",
      request_by: "",
      request_date: "",
      inc: "",
      additional_information: "",
      colloquial_name: "",
      colloquial_name_info: "",
      brand: "",
      part_no: "",
      base_uom: "",
      company_id: "",
      company_name: "",
      average_usage: "",
      safety_stock: "",
      criticallity: "",
      attachment: [],
      attachment_str: "",
      server_code: "",
      message: "",
      item_status: "",
      cataloguer: "",
      json_inc_attribute: "",
      requester_description: "",
      requester_additional_info: "",
      requester_json_inc: "",
      part_no_save: "",
      request_type: "",
      type_input: this.$route.params.type,
      server_route: atob(this.$route.params.server),
      list_inc_parse: [],
      loading_inc: false,
      //--------------------------------------------------------------

      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
      notification: {
        open: false,
        title: null,
        text: null,
      },
      no_timeout: 1000000,
      company_default: "3100",
      list_duplication: [],
      total_duplication: 0,

      list_sort_by: [
        {
          sort_by_id: "INC_CODE",
          sort_by_name: "INC CODE",
        },
        {
          sort_by_id: "INC_NAME",
          sort_by_name: "INC NAME",
        },
        {
          sort_by_id: "SHORT_NAME",
          sort_by_name: "SHORT NAME",
        },
      ],
      sort_by_inc: "INC_CODE",
      sort_type_inc: "ASC",
      is_required: true,
    }
  },

  computed: {
    basic_data_text_format() {
      return this.modalAdditionalInfo.replace(/[;]/g, "<br />")
    },

    disabledAdd() {
      var disabled = false

      if (!this.manufacturer_modal && this.part_no_modal !== "") {
        disabled = true
      }

      if (this.manufacturer_modal && this.part_no_modal === "") {
        disabled = true
      }

      return disabled
    },
  },

  async mounted() {
    this.request_date = this.getDate()
    this.request_by = this.storage_username
    if (this.$route.params.id) {
      await this.getMaterialDetail()
    }

    await this.getDataDropdown()
    await this.getPlant()

    if (this.storage_role != "REQ" && this.storage_role != "CAT") {
      this.$router.push("/login")
    }

    // this.additional_information.disabled;
    // this.server_code = atob(this.$route.params.server);
    // this.getMailApproval();
    // await this.setItemDesc()
  },
  watch: {
    manufacturer() {
      if (this.manufacturer && this.part_no) {
        this.automatic_po = true
      } else {
        this.automatic_po = false
      }
    },
    part_no() {
      if (this.manufacturer && this.part_no) {
        this.automatic_po = true
      } else {
        this.automatic_po = false
      }
    },
  },
  methods: {
    async getDataDropdown() {
      const url_dropdown = this.base_url + "master/dropdown/attribute/"

      const url_company = url_dropdown + "company/company_code"
      const url_manufacturer = url_dropdown + "manufacturer/manufacturer_code"
      const url_industry_sector =
        url_dropdown + "industry_sector/industry_sector_code"

      const url_material_type =
        url_dropdown + "material_type/material_type_code"

      const url_base_unit = url_dropdown + "base_unit/base_unit_code"
      const url_basic_material =
        url_dropdown + "basic_material/basic_material_code"
      const url_order_unit = url_dropdown + "order_unit/order_unit_code"
      const url_divisi = url_dropdown + "divisi/divisi_code"
      const url_material_group =
        url_dropdown + "material_group/material_group_code"
      const url_lab_office = url_dropdown + "lab_office/lab_office_code"
      const url_purchasing_group =
        url_dropdown + "purchasing_group/purchasing_group_code"
      const url_purchasing_value =
        url_dropdown + "purchasing_value/purchasing_value_code"
      const url_lot_size_procedure =
        url_dropdown + "lot_size_procedure/lot_size_procedure_code"
      const url_proc_type = url_dropdown + "proc_type/proc_type_code"
      const url_special_proc = url_dropdown + "special_proc/special_proc_code"
      const url_availibility_check =
        url_dropdown + "availibility_check/availibility_check_code"
      const url_valuation_category =
        url_dropdown + "valuation_category/valuation_category_code"
      const url_valuation_class =
        url_dropdown + "valuation_class/valuation_class_code"
      const url_price_control =
        url_dropdown + "price_control/price_control_code"

      try {
        const company = await this.axios.get(url_company)
        const manufacturer = await this.axios.get(url_manufacturer)
        const industry_sector = await this.axios.get(url_industry_sector)
        const material_type = await this.axios.get(url_material_type)
        const base_unit = await this.axios.get(url_base_unit)
        const basic_material = await this.axios.get(url_basic_material)
        const order_unit = await this.axios.get(url_order_unit)
        const divisi = await this.axios.get(url_divisi)
        const material_group = await this.axios.get(url_material_group)
        const lab_office = await this.axios.get(url_lab_office)
        const purchasing_group = await this.axios.get(url_purchasing_group)
        const purchasing_value = await this.axios.get(url_purchasing_value)
        const lot_size_procedure = await this.axios.get(url_lot_size_procedure)
        const proc_type = await this.axios.get(url_proc_type)
        const special_proc = await this.axios.get(url_special_proc)
        const availibility_check = await this.axios.get(url_availibility_check)
        const valuation_category = await this.axios.get(url_valuation_category)
        const valuation_class = await this.axios.get(url_valuation_class)
        const price_control = await this.axios.get(url_price_control)

        this.list_manufacturer = manufacturer.data ? manufacturer.data : []
        this.list_company = company.data ? company.data : []
        this.list_industry_sector = industry_sector.data
          ? industry_sector.data
          : []
        this.list_material_type = material_type.data ? material_type.data : []
        this.list_base_unit = base_unit.data ? base_unit.data : []
        this.list_basic_material = basic_material.data
          ? basic_material.data
          : []
        this.list_order_unit = order_unit.data ? order_unit.data : []
        this.list_divisi = divisi.data ? divisi.data : []
        this.list_material_group = material_group.data
          ? material_group.data
          : []
        this.list_lab_office = lab_office.data ? lab_office.data : []
        this.list_purchasing_group = purchasing_group.data
          ? purchasing_group.data
          : []
        this.list_purchasing_value = purchasing_value.data
          ? purchasing_value.data
          : []
        this.list_lot_size_procedure = lot_size_procedure.data
          ? lot_size_procedure.data
          : []
        this.list_proc_type = proc_type.data ? proc_type.data : []
        this.list_special_proc = special_proc.data ? special_proc.data : []
        this.list_availibility_check = availibility_check.data
          ? availibility_check.data
          : []
        this.list_valuation_category = valuation_category.data
          ? valuation_category.data
          : []
        this.list_valuation_class = valuation_class.data
          ? valuation_class.data
          : []
        this.list_price_control = price_control.data ? price_control.data : []

        // default
        this.company = this.company_default
      } catch (error) {
        alert(error)
      }
    },

    async getDataMrp() {
      const id = this.purchasing_group
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const url_mrp_control =
        url_dropdown + "mrp_control/purchasing_group_code/" + id

      const url_mrp_group =
        url_dropdown + "mrp_group/purchasing_group_code/" + id

      const url_mrp_type = url_dropdown + "mrp_type/purchasing_group_code/" + id

      const url_mrp_profile =
        url_dropdown + "mrp_profile/purchasing_group_code/" + id

      const reposne_mrp_control = await this.axios.get(url_mrp_control)
      const reposne_mrp_group = await this.axios.get(url_mrp_group)
      const reposne_mrp_type = await this.axios.get(url_mrp_type)
      const response_mrp_profile = await this.axios.get(url_mrp_profile)

      this.list_mrp_control = reposne_mrp_control.data
      this.list_mrp_group = reposne_mrp_group.data
      this.list_mrp_type = reposne_mrp_type.data
      this.list_mrp_profile = response_mrp_profile.data
    },

    async getPlant() {
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const id = this.company
      const url_plant = url_dropdown + "plant/company_id/" + id

      const plant = await this.axios.get(url_plant)
      this.list_plant = plant.data ? plant.data : []
    },

    async getExternalGroup() {
      const id = this.material_group
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const url = url_dropdown + "external_group/material_group_code/" + id

      const response = await this.axios.get(url)
      this.list_external_group = response.data
    },

    async getValuationType() {
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const id = this.valuation_category || "-"
      const url = url_dropdown + "valuation_type/valuation_category/" + id

      const result = await this.axios.get(url)
      this.list_valuation_type = result.data ? result.data : []
    },

    async getStorageLocation() {
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const id = this.plant
      const url = url_dropdown + "storage_location/plant/" + id

      const result = await this.axios.get(url)
      this.list_storage_location = result.data ? result.data : []

      this.is_required = id === "3000" ? false : true
    },

    async submitMaterial(tipe_save) {
      let id = this.$route.params.id
      let url = this.base_url + "material/process/submit"
      let reg_type = "NEW"
      let app_status = ""

      if (id) {
        id = atob(this.$route.params.id)

        if (this.type_input == "edit") {
          url = this.base_url + "material/process/update"
        }

        if (
          this.type_input === "extended" ||
          this.data_material.type_input === "EXT"
        ) {
          reg_type = "EXT"
        }

        if (this.request_type === "UPLOAD") {
          reg_type = "UPLOAD"
        }
      }

      if (tipe_save == "submit") {
        if (this.storage_role === "REQ") {
          app_status = "CAT"
        } else if (this.storage_role === "CAT") {
          app_status = "APP1"
        }
      } else {
        if (this.storage_role === "REQ") {
          app_status = "DRAFT"
        } else if (this.storage_role === "CAT") {
          app_status = "CAT"
        }
      }

      if (this.data_material.status === "DRAFT_CAT") {
        app_status = "DRAFT_CAT"
      }

      const data = {
        request_no: this.request_no,
        request_by: this.storage_fullname,
        inc_code: this.inc_code,
        inc_name: this.inc,
        additional_information: this.additional_information,
        colloquial_name: this.colloquial_name ? this.colloquial_name : "",
        material_number: this.material_number,
        company: this.company,
        plant: this.plant,
        industry_sector: this.industry_sector,
        material_type: this.material_type,
        description: this.description,
        base_unit: this.base_unit,
        division: this.divisi,
        material_group: this.material_group,
        external_group: this.external_group ? this.external_group : "",
        old_material_number: this.old_material_number,
        lab_office: this.lab_office ? this.lab_office : "",
        basic_data_text: this.additional_information,
        basic_material: this.basic_material ? this.basic_material : "",
        purchasing_group: this.purchasing_group,
        order_unit: this.order_unit,
        automatic_po: this.automatic_po ? "X" : "",
        purchasing_value_key: this.purchasing_value_key,
        source_list: this.source_list ? "X" : "",
        manufacturer: this.manufacturer ? this.manufacturer : "",
        part_number: this.part_no ? this.part_no : "",
        original_part_number: this.data_material.part_number,
        remarks: this.remarks ? this.remarks : "",
        mrp_group: this.mrp_group,
        mrp_type: this.mrp_type,
        mrp_control: this.mrp_control ? this.mrp_control : "",
        mrp_profile: this.mrp_profile,
        lot_size_procedure: this.lot_size_procedure,
        proc_type: this.proc_type,
        special_proc: this.special_proc,
        planned_delivery_time: this.planned_delivery_time,
        availibility_check: this.availibility_check,
        valuation_category: this.valuation_category === "S" ? "S" : "",
        valuation_type: this.valuation_type,
        valuation_class: this.valuation_class,
        price_control: this.price_control,
        storage_location: this.storage_location,
        status: app_status,
        requester: this.storage_user_id,
        cataloguer: "",
        approver: "",
        json_inc_attribute: this.json_inc_attribute,
        requester_description: this.description,
        requester_additional_info: this.additional_information,
        requester_json_inc: this.json_inc_attribute,
        type_input: reg_type,
        inserted_by: this.storage_user_id,
        role: this.storage_role,
        user_id: this.storage_user_id,
        id: id,
        possibility_duplicate: this.possibility_duplicate,
      }

      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          const response = await this.axios.post(url, data)
          if (response.status === 200) {
            var request_number = response.data
              ? response.data.request_number
              : ""

            await this.uploadFiles(request_number)

            this.notification = {
              open: true,
              title: "Success",
              text: "Your material has been successfully processed",
            }
          } else {
            this.snackbar = {
              open: true,
              message_text: response.data.message,
              button_type: "error",
            }
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          this.snackbar = {
            open: true,
            message_text:
              "Failed submit material, please check again your input",
            button_type: "error",
          }
        }
      } else {
        this.snackbar = {
          open: true,
          message_text:
            "There are errors or incomplete data. Check your input again",
          button_type: "error",
        }
      }
    },

    getMaterialDetail() {
      var id = atob(this.$route.params.id)
      var self = this
      var url = ""

      if (this.type_input == "edit") {
        url = this.base_url + "material/getdata/detail_material/id/" + id
      } else if (this.type_input == "extended") {
        url =
          this.base_url +
          "material/getdata/detail_initial/MATERIAL_NUMBER/" +
          id
      }

      self.loading = true
      this.axios
        .get(url)
        .then(function(response) {
          self.data_material = response.data
          // alert(JSON.stringify(self.data_material));
          self.request_type = self.data_material.type_input

          if (self.type_input == "edit") {
            self.request_no = self.data_material.request_no
            self.inc_code = self.data_material.inc_code
            self.inc = self.data_material.inc_name
            self.description = self.data_material.description
            self.modalItemDesc = self.data_material.description
            self.modalAdditionalInfo = self.data_material.additional_information
            self.additional_information =
              self.data_material.additional_information
            self.colloquial_name = self.data_material.colloquial_name

            self.manufacturer = self.data_material.manufacturer
            self.part_no = self.data_material.part_number
            self.manufacturer_modal = self.data_material.manufacturer
            self.part_no_modal = self.data_material.part_number

            self.company = self.data_material.company
              ? self.data_material.company
              : self.company_default

            self.plant = self.data_material.plant
            self.industry_sector = self.data_material.industry_sector
            self.material_type = self.data_material.material_type
            self.description = self.data_material.description
            self.base_unit = self.data_material.base_unit
            self.divisi = self.data_material.division
            self.material_group = self.data_material.material_group
            self.old_material_number = self.data_material.old_material_number
            self.lab_office = self.data_material.lab_office
            self.basic_data_text = self.data_material.additional_information
            self.basic_material = self.data_material.basic_material
            self.purchasing_group = self.data_material.purchasing_group
            self.order_unit = self.data_material.order_unit
            self.automatic_po = self.data_material.automatic_po
            self.purchasing_value_key = self.data_material.purchasing_value_key
            self.source_list = self.data_material.source_list
            self.manufacturer = self.data_material.manufacturer
            self.remarks = self.data_material.remarks
            self.mrp_group = self.data_material.mrp_group
            self.mrp_type = self.data_material.mrp_type
            self.mrp_control = self.data_material.mrp_control
            self.mrp_profile = self.data_material.mrp_profile
            self.lot_size_procedure = self.data_material.lot_size_procedure
            self.proc_type = self.data_material.proc_type
            self.special_proc = self.data_material.special_proc
            self.planned_delivery_time =
              self.data_material.planned_delivery_time
            self.availibility_check = self.data_material.availibility_check
            ;(self.valuation_category =
              self.data_material.valuation_category === "S" ? "S" : "N"),
              (self.valuation_type = self.data_material.valuation_type)
            self.valuation_class = self.data_material.valuation_class
            self.price_control = self.data_material.price_control
            self.external_group = self.data_material.external_group
            self.storage_location = self.data_material.storage_location

            if (self.data_material.type_input === "EXT") {
              self.disabledMaterial = true
            }
          }

          self.getDataMrp()
          self.getExternalGroup()
          self.getPlant()
          self.getValuationType()
          self.getStorageLocation()
          self.checkDuplicationPartNumber()

          if (self.type_input == "edit") {
            self.inc = self.data_material.inc_name
            self.shortname = self.inc
            self.attr[0] = self.inc

            self.json_inc_attribute = self.data_material.inc_attribute
            var json_parse_inc = JSON.parse(self.json_inc_attribute)

            self.requester_description =
              self.data_material.requester_description

            self.requester_additional_info =
              self.data_material.requester_additional_info

            var json_requester = self.data_material.requester_json_inc
            self.list_inc_parse = JSON.parse(json_requester)

            if (self.json_inc_attribute) {
              var total_attr = json_parse_inc.length
              for (var a = 1; a <= total_attr; a++) {
                self.attr[json_parse_inc[a].index] = json_parse_inc[a].val

                if (json_parse_inc[a].index == "add") {
                  self.AttrAdditionalInfo = json_parse_inc[a].val
                }
              }
            }
          } else if (self.type_input === "extended") {
            self.material_number = self.data_material.MATERIAL_NUMBER
            self.inc = self.data_material.DESCRIPTION
            self.inc_code = self.data_material.INC_CODE
            self.description = self.data_material.DESCRIPTION
            self.manufacturer = self.data_material.MANUFACTURER
            self.disabledMaterial = true
          }

          setTimeout(() => (self.loading = false), 700)
        })
        .catch(function(error) {
          self.result = error
          self.loading = false
          self.container = true
        })
    },

    //-------------------------------------------------------------------------------------------------------------------------------------------------
    setItemDesc() {
      var self = this
      var row_attr = self.list_inc_attribute.length
      var val = self.attr[0] + ";"
      var val_basic_data = "NAME : " + self.attr[0] + ";"

      if (self.list_inc_attribute[0]) {
        val_basic_data =
          // self.list_inc_attribute[0].ATTRIBUTE_DESC + ":" + self.attr[0] + ";"
          self.list_inc_attribute[0].ATTRIBUTE_DESC + " : " + self.attr[0] + ";"
      }

      var maxlength = 39
      var total_char = self.attr[0].length

      for (var x = 1; x <= row_attr; x++) {
        if (self.attr[x]) {
          var inc_attr = self.attr[x].trim() + ";"
          var count_char_attr = inc_attr.length
          total_char = total_char + count_char_attr

          if (total_char < maxlength) {
            val += inc_attr
          } else {
            var arr_attr_split = inc_attr.split(" ")
            var first_attr_str = arr_attr_split[0]
              ? arr_attr_split[0]
              : arr_attr_split.slice(0, -1)

            var total_first_attr_str = first_attr_str.length

            var last_total_char =
              total_char - count_char_attr + total_first_attr_str

            if (last_total_char <= 40) {
              val += first_attr_str
            }
          }

          val_basic_data +=
            self.list_inc_attribute[x].ATTRIBUTE_DESC + ":" + inc_attr
        }
      }

      var values = []
      if (row_attr) {
        for (var n = 0; n <= row_attr; n++) {
          if (self.attr[n] && self.list_inc_attribute[n]) {
            values.push({
              index: n,
              code: self.list_inc_attribute[n].ATTRIBUTE_CODE,
              desc: self.list_inc_attribute[n].ATTRIBUTE_DESC,
              val: self.attr[n],
            })
          }
        }
      }

      // Description Material
      // var val_material = ""
      // var last_separator_desc = ""

      var str_manufacturer_modal = self.manufacturer_modal
        ? self.manufacturer_modal
        : ""
      var str_part_no_modal = self.part_no_modal

      // // when part no && manufacturer not filled ---------------------------------------------------------------
      // if (str_manufacturer_modal || str_part_no_modal) {
      //   var last_char = val_material.slice(-1)
      //   if (last_char !== ";") {
      //     last_separator_desc = ";"
      //   }
      // }

      var separator = str_manufacturer_modal && str_part_no_modal ? ";" : ""

      // var material_part_new = str_manufacturer_modal + str_part_no_modal

      // var material_part_length_new = 40 - material_part_new.length
      // var item_name_substr_new = val.substring(0, material_part_length_new)

      // val_material =
      //   item_name_substr_new + last_separator_desc + material_part_new

      // // when part no or manufacturer filled ---------------------------------------------------------------
      // if (!str_manufacturer_modal && !str_part_no_modal) {
      //   val_material = val_material.slice(0, -1)
      // }

      var last_char = val.slice(-1)
      if (last_char === ";") {
        val = val.slice(0, -1)
      }

      // when part no && manufacturer filled ---------------------------------------------------------------
      if (self.part_no_modal && self.manufacturer_modal) {
        var material_part =
          ";" + str_part_no_modal + ";" + str_manufacturer_modal
        var item_name = self.attr[0]

        var material_part_length = 40 - material_part.length
        var item_name_substr = item_name.substring(0, material_part_length)

        val = item_name_substr + material_part
      }

      // // when part no && manufacturer filled ---------------------------------------------------------------
      // var material_part_modal = ""
      // var manufacturer_modal = ""
      // var item_name2 = ""
      // var material_part_length2 = ""
      // var manufacturer_length2 = ""
      // var item_name_substr2 = ""
      // var item_name_combine = ""

      // if (self.part_no_modal && !self.manufacturer_modal) {
      //   material_part_modal = ";" + str_part_no_modal
      //   item_name2 = val

      //   material_part_length2 = 39 - material_part_modal.length
      //   item_name_substr2 = item_name2.substring(0, material_part_length2)
      //   item_name_combine = self.getItemNaming(item_name_substr2, item_name2)

      //   val = item_name_combine + material_part_modal
      // }

      // if (!self.part_no_modal && self.manufacturer_modal) {
      //   manufacturer_modal = ";" + str_manufacturer_modal
      //   item_name2 = val

      //   manufacturer_length2 = 39 - manufacturer_modal.length
      //   item_name_substr2 = item_name2.substring(0, manufacturer_length2)
      //   item_name_combine = self.getItemNaming(item_name_substr2, item_name2)

      //   val = item_name_combine + manufacturer_modal
      // }

      self.countString = val.length
      if (self.countString > 40) {
        self.countString = 40
      }

      // val_material = val_material.replace(";;", ";")
      // var valItem = val_material ? val_material.substring(0, 40) : ""
      // const longString = val
      // const maxLength = 40

      // const regex = new RegExp(`.{1,${maxLength}}\\s`, "g")
      // const parts = []
      // let match

      // while ((match = regex.exec(longString)) !== null) {
      //   parts.push(match[0].trim())
      // }

      // Menggabungkan potongan-potongan string menjadi satu string
      // var finalString = parts.join(" ")

      // if (finalString.length > 40) {
      //   finalString = finalString.substring(0, 40) // Ambil hanya 40 karakter pertama
      //   var lastSpaceIndex = finalString.lastIndexOf(" ") // Cari posisi spasi terakhir dalam 40 karakter pertama
      //   if (lastSpaceIndex !== -1) {
      //     finalString = finalString.substring(0, lastSpaceIndex) // Potong hingga spasi terakhir
      //   }
      // }

      self.modalItemDesc = self.attr[0] ? val : ""

      // Basic Data Text-----------------------------------------------------------------------------------
      var additionalInfo = self.AttrAdditionalInfo
        ? "ADDITIONAL INFO : " + self.AttrAdditionalInfo
        : ""

      if (additionalInfo != "") {
        values.push({
          index: "add",
          code: "ADDITIONAL_TEXT",
          desc: "ADDITIONAL TEXT",
          val: additionalInfo,
        })
        additionalInfo = "ADDITIONAL INFO : " + self.AttrAdditionalInfo + ";"
      }

      if (str_part_no_modal && str_manufacturer_modal) {
        str_part_no_modal = "PART NUMBER : " + str_part_no_modal
        str_manufacturer_modal = "MANUFACTURER : " + str_manufacturer_modal
      } else {
        str_part_no_modal = ""
        str_manufacturer_modal = ""
      }

      var valAdditional =
        val_basic_data +
        additionalInfo +
        str_part_no_modal +
        separator +
        str_manufacturer_modal

      if (!str_manufacturer_modal && !str_part_no_modal) {
        valAdditional = valAdditional.slice(0, -1)
      }

      self.json_inc_attribute = JSON.stringify(values)

      self.modalAdditionalInfo = valAdditional
    },

    addDescription() {
      this.description = this.modalItemDesc
      this.additional_information = this.modalAdditionalInfo
      this.part_no = this.part_no_modal
      this.manufacturer = this.manufacturer_modal
      this.checkDuplicationPartNumber()

      this.dialog2 = false
    },

    changeDescription() {
      this.manufacturer_modal = this.manufacturer
      this.part_no_modal = this.part_no
      this.setItemDesc()

      this.description = this.modalItemDesc
      this.additional_information = this.modalAdditionalInfo
    },

    selectInc(event, code, name, colloquial_name) {
      this.inc_code = code
      this.inc = name
      this.shortname = name
      this.dialog = false
      this.colloquial_name_info = colloquial_name
      this.modalAdditionalInfo = ""
      this.modalItemDesc = ""
      this.part_no_modal = ""
      this.manufacturer = ""
      this.additional_information = ""
      this.description = ""

      this.clearAll()
      this.attr = []
    },

    getInc() {
      var self = this
      var val = self.searchInc
      var url = self.base_url + "search/inc"
      self.loading_inc = true

      this.axios
        .post(url, {
          param: val,
          sort_by: self.sort_by_inc,
          sort_type: self.sort_type_inc,
        })
        .then(function(response) {
          self.list_inc = response.data
        })
        .finally(() => {
          self.loading_inc = false
        })
    },

    getAttribute() {
      var self = this
      var inc_code = self.inc_code
      var url = this.base_url + "dropdown/inc_attribute/" + inc_code
      this.axios.get(url).then(function(response) {
        self.list_inc_attribute = response.data
        self.attr[0] = self.shortname
      })
    },

    modalInc() {
      this.dialog = true
      this.getInc()
    },

    modalAttribute() {
      this.disabledAttr[0] = true
      this.getAttribute()
      this.dialog2 = true
      this.countString = this.modalItemDesc.length
      // this.setItemDesc()
    },

    uploadFiles(param_request_no) {
      if (this.attachment.length === 0) {
        return
      }

      var request_no = param_request_no ? param_request_no : this.request_no

      let formData = new FormData()
      this.attachment.forEach((file, index) => {
        let name = this.storage_user_id + "-" + file.name
        formData.append(`file${index}`, file)
        formData.append(`filename${index}`, name)
      })

      const filenames = this.attachment.map((file) => file.name)
      formData.append("filenames", JSON.stringify(filenames))
      formData.append("request_number", request_no)
      formData.append("user_id", this.storage_user_id)

      var url = this.base_url + "material/upload/files"
      this.axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console(response.data)
        })
        .catch((error) => {
          console("Error Upload File" + error)
        })
    },

    getDate() {
      var date = new Date()
        .toLocaleString("en-US", { hour12: false })
        .split(" ")
      //var time = date[1];
      var mdy = date[0]

      mdy = mdy.split("/")
      var month = parseInt(mdy[0])
      var day = parseInt(mdy[1])
      var year = parseInt(mdy[2])

      // Putting it all together
      var formattedDate = year + "-" + month + "-" + day
      return formattedDate
    },

    clearAll() {
      var self = this
      self.description = ""
      self.modalItemDesc = ""
      self.additional_information = ""
      self.AttrAdditionalInfo = ""
    },

    routeList() {
      if (this.storage_role === "REQ") {
        this.$router.push("/listRegister")
      }

      if (this.storage_role === "CAT" && this.request_type !== "UPLOAD") {
        this.$router.push("/listCatalogProcess")
      }

      if (this.storage_role === "CAT" && this.request_type === "UPLOAD") {
        this.$router.push("/listCatalogUploadMaterial")
      }
    },

    async checkDuplicationPartNumber() {
      let id = this.$route.params.id
      const url = this.base_url + "material/process/check_duplication"
      const data = {
        id: id,
        part_number: this.part_no_modal,
        manufacturer: this.manufacturer_modal,
        original_part_number: this.data_material.part_number,
        original_manufacturer: this.data_material.manufacturer,
      }

      const response = await this.axios.post(url, data)
      this.list_duplication = response.data.data

      this.total_duplication = this.list_duplication.filter(
        (res) =>
          res.part_number === this.part_no_modal &&
          res.manufacturer === this.manufacturer_modal &&
          res.manufacturer !== ""
      ).length

      //---- Set Field Possibility Duplicate
      if (!this.list_duplication.length) {
        this.possibility_duplicate = "LOW"
      }

      if (this.list_duplication.length) {
        this.possibility_duplicate = "MEDIUM"
      }

      if (this.total_duplication > 0) {
        this.possibility_duplicate = "HIGH"
      }
    },

    getItemNaming(item_name, long_desc) {
      var item_name_split = long_desc.split(";")
      var maxlength2 = item_name.length
      var total_length = 0
      var item_name_combine = ""

      for (var b = 0; b < item_name_split.length; b++) {
        var b_item = item_name_split[b].trim() + ";"
        var b_item_length = item_name_split[b].length

        total_length = total_length + b_item_length

        if (total_length < maxlength2) {
          item_name_combine += b_item
        }
      }

      item_name_combine = item_name_combine.replace(";;", "")

      var last_char = item_name_combine.slice(-1)
      if (last_char === ";") {
        item_name_combine = item_name_combine.slice(0, -1)
      }

      /* eslint-disable no-console */
      console.log("long desc " + long_desc)
      console.log("maxlength " + maxlength2)
      console.log("total length " + total_length)
      console.log("item_name combine " + item_name_combine)
      /* eslint-enable no-console */

      return item_name_combine
    },
  },
}
</script>

<style>
/* .title-table {
  font-size: 16px !important;
  display: block;
  margin-top: 12px;
} */

.v-btn {
  text-transform: unset !important;
  letter-spacing: 0.7px !important;
}

.fltable td {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
}

.general-table td {
  vertical-align: top;
  padding-bottom: 0px !important;
}

.form-box {
  border: 1.5px solid #f3f3f3;
  padding: 30px 25px;
}
/* 
.v-data-table__empty-wrapper {
  display: none !important;
} */

.sticky-top {
  position: sticky !important;
  top: 100px !important;
}

.sticky-form {
  position: sticky !important;
  top: 0px !important;
  z-index: 10;
  width: 100%;
  padding: 0px 10px;
}

.required {
  color: #ff0000;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-left: -10px !important;
  color: #ff5252 !important;
}
</style>
